<template>
    <div>test</div>
</template>

<script>
    export default {
        name: "Test"
    }
</script>

<style scoped>

</style>